/* eslint-disable @angular-eslint/no-input-rename */
import {
  ChangeDetectionStrategy,
  Component,
  Input,
  ViewEncapsulation,
} from '@angular/core';

import { SharedModule } from '../../../shared.module';

@Component({
  selector: 'app-widget-summary-display',
  templateUrl: './widget-summary-display.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  imports: [SharedModule],
})
export class WidgetSummaryDisplayComponent {
  @Input() billingAddress: string;

  @Input() accountName: string;

  @Input() lastInvoiceDate: Date;

  @Input() lastPaymentDate: Date;

  @Input() lastPaymentAmount: number;

  @Input() loading: boolean = true;
}
